export function failedPayment(paymentHistory) {
  if (!paymentHistory) return false;

  const latestPayment = paymentHistory.values().next().value;
  return !!latestPayment && latestPayment.status === 'failed';
}



// WEBPACK FOOTER //
// ./src/helpers/payment.js